import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { callBinary } from "@/utilities/geotabBinary";

type MediaBlob = { id: string; blob: Blob; contentType?: string; filename?: string };

export function useDownloadMedia(mediaFileIds: string[]) {
  const { activeSessionId, database, username, internalSessionId } = useGeotabClient();
  if (!internalSessionId) {
    console.error("Internal session ID is required");
  }
  const apiUrl = "https://my.geotab.com/apiv1";

  return useQuery<MediaBlob[], Error>({
    enabled: !!internalSessionId && Array.isArray(mediaFileIds) && mediaFileIds.length > 0,
    queryKey: ["mediaFiles:blobs", activeSessionId, ...[...mediaFileIds].sort()],
    queryFn: async ({ signal }) => {
      const results = await Promise.all(
        mediaFileIds.map(async id => {
          const { blob, contentType, filename } = await callBinary(
            apiUrl,
            "DownloadMediaFile",
            { mediaFile: { id } },
            internalSessionId ?? undefined,
            database,
            username,
            signal,
          );
          return { id, blob, contentType, filename };
        }),
      );
      return results;
    },
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });
}
